// Pages/Settings/Sequences/index.tsx
import React, { useState } from 'react';
import { useInvoiceSequences } from '../../../hooks/useInvoiceSequences';
import { InvoiceNumberSequence } from '@/types/invoiceNumberSeq.types';
import { SequenceForm } from '../../../components/Sequences/SequenceForm';
import SequenceList from '../../../components/Sequences/SequenceList';

export function SequencesPage() {
  const { createSequences, updateSequences, loading } = useInvoiceSequences();
  const [currentSequence, setCurrentSequence] = useState<InvoiceNumberSequence | null>(null);
  const [isFormVisible, setIsFormVisible] = useState(false);
  
  const handleEdit = (sequence: InvoiceNumberSequence) => {
    setCurrentSequence(sequence);
    setIsFormVisible(true);
  };
  
  const handleCreateNew = () => {
    setCurrentSequence(null);
    setIsFormVisible(true);
  };
  
  const handleFormCancel = () => {
    setIsFormVisible(false);
    setCurrentSequence(null);
  };
  
  const handleFormSave = async (sequence: Omit<InvoiceNumberSequence, 'sequence_id' | 'last_reset_date'>) => {
    if (currentSequence) {
      // Update existing sequence
      const updated = await updateSequences(currentSequence.sequence_id, sequence);
      if (updated) {
        setIsFormVisible(false);
        setCurrentSequence(null);
      }
    } else {
      // Create new sequence
      const created = await createSequences(sequence);
      if (created) {
        setIsFormVisible(false);
      }
    }
  };
  
  return (
    <div className="container1 mx-auto ">
      {/* <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-gray-800">Invoice Number Sequences</h1>
        {!isFormVisible && (
          <button 
            onClick={handleCreateNew}
            className="bg-primary text-white hover:bg-primary-dark h-10 px-4 rounded-sm font-medium transition-colors duration-150"
          >
            Create New Sequence
          </button>
        )}
      </div> */}
      
      {isFormVisible ? (
        <SequenceForm
          sequence={currentSequence || undefined}
          onSave={handleFormSave}
          onCancel={handleFormCancel}
          isSubmitting={loading}
        />
      ) : (
        <SequenceList
        />
      )}
    </div>
  );
}